import Immutable from 'immutable'
import { TOGGLE_SHOW_ALL_PRODUCTS } from '../actions/userAction'

const defaultState = Immutable.fromJS({
  showAllProducts: false
})

export default (s, action) => {
  const state = s || defaultState
  if (action.type === TOGGLE_SHOW_ALL_PRODUCTS) {
    return state.withMutations((st) => {
      if (action.payload !== null) {
        st.set('showAllProducts', action.payload)
      }
    })
  }
  return state
}

export const isShowAllProducts = ({ userAction }) => {
  return {
    showAllProducts: userAction.get('showAllProducts')
  }
}
